import { checkValidImgUrl } from './editor-config';

export function markdownItThirdPartyImage(md: any) {
  const originalImage = md.renderer.rules.image;
  md.renderer.rules.image = (
    tokens: any,
    idx: any,
    options: any,
    env: any,
    self: any,
  ) => {
    const token = tokens[idx];

    const src = token.attrGet('src');

    token.attrSet('src', checkValidImgUrl(src));
    token.attrSet('style', 'max-height:300px');

    return originalImage(tokens, idx, options, env, self);
  };
}
